module.exports = __webpack_public_path__ + "static/buyer-error-dee1d69ee09e389f08efcb8bf3b41c4c.gif";